import { StateSetter } from 'react';

import { Loader, Switch } from 'components/Blocks';

import { actions, useActiveOwnershipBlock, User } from 'entities';

import { useTeamProfile } from '../context';
import { useUser } from 'hooks/user';

interface UserStatusProps {
  children?: never;
  user: User;
  updateUsers: StateSetter<User[]>;
}

function UserStatus({ user, updateUsers }: UserStatusProps): JSX.Element {
  const loggedUser = useUser();
  const { canMutateEntities } = useTeamProfile();

  const { id, disabled } = user;

  const userHasAuthority = [
    canMutateEntities,
    user.isSysAdmin ? loggedUser.isSysAdmin : true,
  ].every(Boolean);

  const toggle = actions.users.toggleUser.use({
    onSuccess: () => {
      updateUsers((old) =>
        old.map((existing) =>
          existing.id !== id ? existing : { ...existing, disabled: !disabled },
        ),
      );
    },
  });

  const [, disableUser] = useActiveOwnershipBlock(id, async () =>
    toggle.execute({ disabled: true, id }),
  );

  if (toggle.loading) return <Loader type="dualRing" />;

  return (
    <Switch
      disabled={!userHasAuthority}
      checked={!disabled}
      onChange={disabled ? () => toggle.execute({ disabled: false, id }) : disableUser}
      size="small"
    />
  );
}

export default UserStatus;
